import React from 'react';
import { Counter, useClassnames } from '@wb-tech/ui-react';
import { useTranslation } from 'react-i18next';

import { useCheckNewPromotions } from '#hook/use-check-new-promotions';

import style from './index.module.pcss';

export const PromotionsAlert = () => {
    const cn = useClassnames(style);
    const { t } = useTranslation();

    const { isNewPromotionsAvailable } = useCheckNewPromotions();

    if(!isNewPromotionsAvailable) {
        return null;
    }

    return (
        <Counter className={cn('promotions-alert')}>
            {t('components.header.nav-tabs.addition-content.promotions')}
        </Counter>
    );
};
